<template>
  <div class="background" :class="{'no-bg': noBg}">
    <div class="main">
      <!-- 公共头部 -->
      <div class="header">
        <i class="iconfont iconx" @click="close"></i>
        <img class="header-tips" src="@/assets/image/zuanshi.png" alt="">
        <div class="header-content">
          <div class="avatar-box">
            <img :src="personInfo.avatar_url" alt="">
            <span>{{personInfo.name}}</span>
          </div>
          <div>
            <p v-if="isSuperMember">你已是超级简历终身会员</p>
            <p v-else-if="personInfo.is_membership">超级会员：{{moment(personInfo.membership_expired_at).format('YYYY-MM-DD')}} 到期</p>
            <p v-else>{{ headerTips }}</p>
          </div>
        </div>
      </div>
      <!-- 弹窗主题区域 -->
      <div class="content">
        <div class="content-left">
          <div class="vip-characteristic">
            <div class="characteristic-header">
              <img src="https://logo.wondercv.com/banners/LNtWaqGYtlUwIGK.png" alt="">
              <div>会员权益一览</div>
            </div>
            <div v-if="pic!==WONDER_PRICE && pic!==150" class="vip-inexpensive">
              <!-- <div class="vip-inexpensive-top"> -->
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.manyResumeActive" alt=""></div>
                <p v-if="pic===FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">15份简历</p>
                <p v-else>5份简历</p>
                <span>满足更多岗位投递</span>
              </div>
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.detectionActive" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">无限次智能检查</p>
                <p v-else-if="pic=== YEAR_PRICE">1500次检查</p>
                <p v-else>100次智能检查</p>
                <span>一键 AI 智能检查</span>
              </div>
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.cv_transitionActive" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">无限次简历翻译</p>
                <p v-else-if="pic=== YEAR_PRICE">200次简历翻译</p>
                <p v-else>10次简历翻译</p>
                <span>中英一键转换</span>
              </div>
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.template_active" alt=""></div>
                <p>海量模板</p>
                <span>解锁所有专业模板</span>
              </div>
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.job_active" alt=""></div>
                <p>专属社群</p>
                <span>会员求职社群</span>
              </div>
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.resume1_active" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">100次简历纠错</p>
                <p v-else>10次简历纠错</p>
                <span>语义纠错完善细节</span>
              </div>
              <!-- </div> -->
              <!-- <div class="vip-inexpensive-bottom"> -->
              <div class="kind">
                <div class="div-img"><img :src="defaultImg.image_active" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">5次证件照制作</p>
                <p v-else>1次证件照制作</p>
                <span>极速制作一键使用</span>
              </div>
              <div class="kind">
                <div class="div-img"><img src="https://logo.wondercv.com/banners/Lh6sfRlavDmifDb.png" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">无限次AI模拟面试</p>
                <p v-else>30次AI模拟面试</p>
                <span>GET满分面试答案</span>
              </div>
              <div class="kind">
                <div class="div-img"><img src="https://logo.wondercv.com/banners/drEaR1FRnkA9Qk3.png" alt=""></div>
                <p v-if="pic=== FOREVER_PRICE || pic === FOREVER_PLUS_PRICE">无限次AI简历润色</p>
                <p v-else>100次AI简历润色</p>
                <span>一键优化简历内容</span>
              </div>
              <div :class="pic === FOREVER_PLUS_PRICE || pic === FOREVER_PRICE ? 'kind' : 'kind opcity'">
                <div class="div-img"><img :src="defaultImg.resume_repair" alt=""></div>
                <p>365天简历恢复</p>
                <span>避免误删信息丢失</span>
              </div>
              <div :class="pic === FOREVER_PLUS_PRICE || pic === FOREVER_PRICE ? 'kind' : 'kind opcity'">
                <div class="div-img"><img src="https://logo.wondercv.com/banners/PT8AP8Fkl2ZpUZE.png" alt=""></div>
                <p>专属客服</p>
                <span>问题反馈优先解决</span>
              </div>
              <!-- </div> -->
            </div>
            <div v-else class="vip-expensive">
              <div class="left">
                <img :src="defaultImg.equity" alt="">
              </div>
              <div class="and">
                <img :src="defaultImg.add" alt="">
              </div>
              <div class="right">
                <img :src="defaultImg.typeImg" alt="">
              </div>
            </div>
          </div>
          <div class="vip-options">
            <div class="vip-options-title">选择会员版本</div>
            <div class="member-type-content">
              <div
                class="vip-item"
                v-for="(item,index) in options"
                :key="index"
                :class="{active: activeOption === index}"
                data-growing-container
                :data-growing-idx="index"
                @click="handleClickUpdateOrder(item.pic, item.value, index, item.type)"
              >
                <div v-if="displayDiscountedPrice(item, index)" class="vip-countdown-wrapper">
                  倒计时&nbsp;
                  <Countdown
                    :start-time="purchaseRecordData && purchaseRecordData.order_time"
                    :current-time="purchaseRecordData && purchaseRecordData.time_now"
                    :duration="memberPopupData.duration"
                  ></Countdown>
                </div>

                <div v-if="item.type === 'forever'" class="recommend-final-vip-layout"> 限量送超值权益 </div>

                <p class="time">{{ item.time }}</p>

                <div class="pic-container">
                  <span class="pic-tip">￥</span>
                  <span class="pic-text">
                    {{ displayDiscountedPrice(item, index) ? displayDiscountedPrice(item, index).discountPrice : (includeRighsPrice(item, index) || item.pic) }}
                  </span>
                  <template v-if="displayDiscountedPrice(item, index)">
                    <span class="discount-tip">￥</span>
                    <span class="discount-text">{{item.pic}}</span>
                  </template>
                </div>

                <div 
                  v-if="displayDiscountedPrice(item, index)"
                  class="discount-desc"
                >
                  限时立减{{displayDiscountedPrice(item, index).money}}
                </div>

                <div v-else-if="item.average" class="average-text">{{ item.average }}</div>
              </div>
            </div>
            <div class="rights-tips">
              加购精选求职包
              <div class="label">
                {{ options[activeOption].type === 'forever' ? '终身会员免费送' : '打包5折超优惠' }}
              </div>
            </div>
            <div class="rights-list-content">
              <div
                v-for="(item, index) in rightsListData"
                :key="index"
                class="rights-item"
                :class="{'active': rightsIds.includes(item.id)}"
                @click="handleClickRightsItem(item)"
              >
                <div class="intro-container">
                  <div class="intro-content">
                    <span class="title">{{ item.title }}</span>
                    <span class="detail-btn" @click.stop="handleChangeRightsState(item)">详情</span>
                  </div>
                  <div class="intro-desc">{{item.subtitle}}</div>
                </div>
                <div class="price-intro">
                  <div class="real-price">
                    <span class="rmb-symbol">¥</span>
                    <span class="number">{{ item.price }}</span>
                  </div>
                  <div class="original">¥{{ item.crossed_price }}</div>
                </div>
              </div>
            </div>
            <div v-if="unionMembers && unionMembers.length" class="rights-tips coupon-member-tips">
              <div class="title-content">
                联合会员权益
                <div v-if="options[activeOption].type === 'forever'" class="label">终身会员免费送</div>
              </div>
              <div v-if="options[activeOption].type === 'forever' && surplusCount" class="surplus-count">
                仅剩
                <div class="count-item">{{ surplusCount[0] }}</div>
                <div class="count-item">{{ surplusCount[1] }}</div>
                份
              </div>
            </div>
            <div class="rights-list-content">
              <div
                v-for="(item, index) in unionMembers"
                :key="index"
                class="rights-item union-member-item"
                :class="{'active': unionMemberIds.includes(item.id)}"
                @click="handleClickUnionMemberItem(item)"
              >
                <div class="intro-wrapper">
                  <img class="logo" :src="item.image" alt="">
                  <div class="intro-container">
                    <div class="intro-content">
                      <span class="title">{{ item.title }}</span>
                    </div>
                    <div class="intro-desc">{{item.subtitle}}</div>
                  </div>
                </div>
                <div class="price-intro">
                  <div class="real-price">
                    <span class="rmb-symbol">¥</span>
                    <span class="number">{{ item.price }}</span>
                  </div>
                  <div class="original">¥{{ item.crossed_price }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-right">
          <!-- 右侧的扫码支付 -->
          <div class="pay-fixed">
            <div class="pay-title">支付订单</div>
            <div class="pay-type-content">
              <img src="https://files.wondercv.com/web/member/wechat.png">
              <img src="https://files.wondercv.com/web/member/alipay.png">
              扫码支付，解锁权益
            </div>
            <div class="Qrcode">
              <qrcode-vue :value="`${host}/pay/type?type=member&orderId=${orderId}&coupon_id=${couponsToken}&isSuper=${pic === FOREVER_PRICE || pic === 80 ? 'isSuper' : ''}&isSuperPlus=${pic === WONDER_PRICE || pic === 100 ? 'isSuperPlus' : ''}&repurchase_discount=${isHalfYearMember ? 1 : 0}${qrPayLink}`"
                          :size="126"
                          class="Qrcode-component"/>
              <div class="qrcode-not" v-show="!Math.max(...[(currentRealPrice()-couponsPic).toFixed(2),0])">
                <p>无需扫码</p>
                <p>点击「立即购买」</p>
              </div>
            </div>
            <div class="price-content">
              实付：
              <span class="mark">￥</span>
              <div class="price">{{Math.max(...[(currentRealPrice()-couponsPic).toFixed(2),0])}}</div>
              <div class="price-detail" @click="priceDetailState = true">
                明细
                <i class="iconfont iconchevron-right"></i>
              </div>
            </div>
            <a class="protocol-link" href="/cvs/pay/privacy-clause" target="_blank">支付即代表同意《会员服务协议》</a>
            <div class="pay-success-btn">
              <div class="comps" @click.stop="openComps">
                <span>兑换优惠券</span>
                <!-- <div class="line" /> -->
              </div>
              <template v-if="isShowBtn">
                <div class="btn" @click="handleClickCheck" v-if="Math.max(...[(currentRealPrice()-couponsPic).toFixed(2),0])">
                  我已支付
                </div>
                <div class="btn" @click="handleClickPay" v-else>
                  立即购买
                </div>
              </template>
              <div class="text" v-show="isShowError">遇到问题？请咨询客服</div>
            </div>
          </div>
          <div class="price-detail-slider" :class="{'active': priceDetailState}">
            <div class="price-detail-header">
              合计明细
              <i class="iconfont iconclose" @click="priceDetailState = false"></i>
            </div>
            <div class="price-detail-content">
              <template v-if="priceIntroData">
                <div class="price-intro-title">会员价格</div>
                <div v-if="priceIntroData.membershipIntro" class="intro-content" style="margin-bottom: 20px;">
                  <div>{{ priceIntroData.membershipIntro.title }}</div>
                  <div>{{ priceIntroData.membershipIntro.price }}</div>
                </div>
                <div v-if="priceIntroData.pickUnionMemberPrice.length" class="price-intro-title">联合会员价格</div>
                <div
                  v-for="(item, index) in priceIntroData.pickUnionMemberPrice"
                  :key="index"
                  class="intro-content"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.price }}</div>
                </div>
                <div v-if="priceIntroData.pickRightsPrice.length" class="price-intro-title">
                  求职包价格
                  <div v-if="activeOption !== 0 && rightsIds.length > 1" class="discount-label">
                    {{ priceRatio * 10 }}折
                  </div>
                </div>
                <div
                  v-for="(item, index) in priceIntroData.pickRightsPrice"
                  :key="index + 4"
                  class="intro-content"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.price }}</div>
                </div>
                <div v-if="couponsPic" class="price-intro-title coupon-title">
                  优惠券价格
                  <span class="coupon-price">¥{{ couponsPic }}</span>
                </div>
              </template>
            </div>
            <div class="finnal-price">
              合计
              <span>¥{{Math.max(...[(currentRealPrice()-couponsPic).toFixed(2),0])}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--兑换优惠券弹窗开关 -->
    <div class="comps-container flex" v-if="compsState" @click.stop="closeComps">
      <div class="use-comps-container" @click.stop>
        <div class="title">兑换优惠券</div>
        <div class="input-container">
          <input type="text" placeholder="请输入兑换码" class="comps-input"  v-model="couponsText">
          <span class="comps-tips cursor_p" @click.stop="handleClickSubmit">兑换</span>
        </div>
        <div class="comps-container-choose">
          <div class="page left" @click.stop="handleClickTo(1)" v-show="couponsList.length>1&&couponsIndex!=0">
            <i class="iconfont iconchevron-left"></i>
          </div>
          <div class="page right" @click.stop="handleClickTo(-1)"
               v-show="couponsList.length>1&&couponsIndex!=-(couponsList.length-1)">
            <i class="iconfont iconchevron-right"></i>
          </div>
          <div class="coupons-list" :style="{width: `${460 * couponsList.length}px`}" v-if="couponsList.length>0">
            <div class="list-container" v-for="(list,index) in couponsList" :key="index"
                 :style="{transform:`translateX(${couponsIndex*460}px)`}">
              <div class="list-item" v-for="(item,index1) in list" :key='index1' :class="{'active':item.id==tempComps.id}"
                   @click="handleClickSelectCoupons(item)">
                <div class="item-pic" v-if="item.cent">¥ <span>{{item.cent/100}}</span></div>
                <div class="item-pic" v-if="item.discount"><span>{{item.discount * 10}}折</span></div>
                <div class="item-pic" v-if="item.member_days"><span>{{item.member_days}}天</span></div>
                <div class="item-text-time">
                  <p>{{item.coupon_name||item.name}}</p>
                  <p>有效期：{{moment(item.expiry).format('YYYY-MM-DD')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-container flex">
          <div class="btn cancel-btn cursor_p" @click="closeComps">取消</div>
          <div class="btn use-btn cursor_p" @click="useComps">使用</div>
        </div>
      </div>
    </div>
    <div v-if="rightsDetailState" class="rights-detail-container" @click="rightsDetailState = !rightsDetailState">
      <img @click.stop :src="currentRightsDetailImage" alt="">
    </div>
    <RemainDialog
      v-if="remainDialogState"
      :rights-list-data="rightsListData"
      @handleConfirmRights="updateCurrentOrder"
      @handleCancelRights="handleCancelRights"
    ></RemainDialog>
    <RemainDialog
      v-if="unionRemainState"
      type="union"
      title="确认取消「联合会员权益」吗？"
      desc="限时优惠机会失不再来！"
      confirm-btn-text="我全都要"
      :rights-list-data="unionMembers"
      @handleConfirmRights="updateCurrentOrder"
      @handleCancelRights="handleCancelRights"
    ></RemainDialog>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from "vuex"
  import Cookies from 'js-cookie'
  import moment from "moment"
  import qrcodeVue from 'qrcode-vue';
  import api from "../../../api";
  import {get_tUser, routerTo} from "@/assets/js/util"
  import {toLogin} from "@/assets/js/jwt";
  import { MEMBER_STATE_DATA } from '@/assets/js/const';

  import manyResumeActive from '@/assets/image/member/many_resume_active.png'
  import bookActive from '@/assets/image/member/book_active.png'
  import detectionActive from '@/assets/image/member/detection.png'
  import cv_transitionActive from '@/assets/image/member/cv_transition_active.png'
  import template_active from '@/assets/image/member/template_active.png'
  import image_active from '@/assets/image/member/image_active.png'
  import resume1_active from '@/assets/image/member/resume1_active.png'
  import job_active from '@/assets/image/member/job_active.png'
  import resume_repair from '@/assets/image/member/resume_repair.png'
  import course_active from '@/assets/image/member/course_active.png'
  import resume_active from '@/assets/image/member/resume_active.png'

  import equity from '@/assets/image/member/equity.png'
  import add from '@/assets/image/member/add.png'
  import typeImg from '@/assets/image/member/type.png'

  import Countdown from '@/components/Countdown.vue';
  import RemainDialog from './remainDialog.vue';
  import { MONTH_PRICE, YEAR_PRICE, FOREVER_PRICE, WONDER_PRICE, FOREVER_PLUS_PRICE, ORDER_IN, BUY_IN } from '@/assets/js/const'

  export default {
    name: "payAlert",
    props: {
      activePic: {
        type: Number,
        default: MONTH_PRICE
      },
      browseType: {
        type: [String, undefined],
        default: undefined
      },
      noBg: {
        type: Boolean,
        default: false
      },
      origin: {
        type: String,
        default: null
      },
      // orderId: {
      //   type: String
      // }
    },
    data() {
      return {
        MONTH_PRICE,
        YEAR_PRICE,
        FOREVER_PRICE,
        WONDER_PRICE,
        FOREVER_PLUS_PRICE,
        defaultImg : {
          manyResumeActive,
          equity,
          add,
          typeImg,
          bookActive,
          detectionActive,
          cv_transitionActive,
          template_active,
          image_active,
          resume1_active,
          job_active,
          resume_repair,
          course_active,
          resume_active
        },
        moment,
        activeOption: 0,
        hasRights: false,
        rightsDetailState: false,
        currentRightsDetailImage: '',
        rightsIds: [],
        rightsListData: [],
        remainDialogState: false,
        unionMembers: [],
        unionMemberIds: [],
        unionRemainState: false,
        priceDetailState: false,
        surplusCount: '50',
        //会员选项
        options: [
          {
            id: 3,
            pic: FOREVER_PRICE,
            oldPic: 199,
            time: "终身会员",
            text: "最实惠 越用越省",
            value: 1000,
            type: 'forever',
            average: '终身享权益'
          },
          {
            id: 0,
            pic: MONTH_PRICE,
            oldPic: 25,
            time: "月度会员",
            text: "平均每天 0.6 元",
            value: 1,
            type: 'month',
            average: '0.6元/日'
          },
          {
            id: 2,
            pic: YEAR_PRICE,
            oldPic: 99,
            time: "年度会员",
            text: "平均每天 0.2 元",
            value: 12,
            type: 'year',
            average: '0.2元/日'
          }
        ],
        //优惠券列表
        couponsList: [],
        //优惠券左移右移下标
        couponsIndex: 0,
        //价格
        pic: 0,
        //优惠券价格
        couponsPic: 0,
        //优惠券id
        couponsToken: "",
        //优惠券兑换码
        couponsText: "",
        //点击支付时状态（做假节流）
        isPayLoading: false,
        host: "",//域名
        isShowBtn: false,
        isError: false,
        timer: null,//轮训定时器
        isShowError: false,
        // 优惠券类型
        codePlan:{
          1: 'member',   // 会员
          2: 'cv',   // 金额
          3: 'discount'   // 折扣
        },
        orderId: '',   // 订单 ID
        membershipsTitle:['简历份数', 'AI 智能检查', '一键生成英文简历', '会员简历模板', '证件照制作', '简历纠错', '1V1简历修改优惠券', '199元笔面经', '79元在线课程', '求职辅导立减500', '15分钟专属求职答疑', ],
        vipTemplateText: { // 会员权益
          "简历份数": "15",
          "AI 智能检查": "无限",
          "一键生成英文简历": "无限",
          "会员简历模板": "限时",
          "证件照制作": '5',
          "简历纠错": "100",
          "1V1简历修改优惠券": "",
          "199元笔面经": "对勾Plus",
          "79元在线课程": "对勾Plus",
          "求职辅导立减500": "对勾Plus",
          "15分钟专属求职答疑": "对勾Plus",
        },
        vipDescTemplateMapping: {
          "简历份数": {
            [MONTH_PRICE]: 5,
            [YEAR_PRICE]: 5,
          },
          "AI 智能检查": {
            [MONTH_PRICE]: 100,
            [YEAR_PRICE]: 1500,
          },
          "一键生成英文简历": {
            [MONTH_PRICE]: 10,
            [YEAR_PRICE]: 200,
          },
          "证件照制作": {
            [MONTH_PRICE]: 1,
            [YEAR_PRICE]: 1,
          },
          "简历纠错": {
            [MONTH_PRICE]: 10,
            [YEAR_PRICE]: 10,
          },
          "1V1简历修改优惠券": {
            '超级会员': '49元',
            '终身会员': '39元',
          },
        },
        memberships: [
          {
            img: '/many_resume_active.png',
            [`${MONTH_PRICE}img`]: '/5_cv.png',
            [`${YEAR_PRICE}img`]: '/5_cv.png',
            normal: '/many_resume_normal.png',
            title: '15份简历',
            [`${MONTH_PRICE}title`]: '5份简历',
            [`${YEAR_PRICE}title`]: '5份简历',
            description: '不同职位投递需求',
            life: false,
            plus: false
          },
          {
            img: '/cv_check_active.png',
            normal: '/tools_normal.png',
            title: '无限次 AI 检查',
            description: '一键 AI 智能检查',
            [`${MONTH_PRICE}title`]: '100次 AI 检查',
            [`${YEAR_PRICE}title`]: '1500次 AI 检查',
            life: false,
            plus: false
          },
          {
            img: '/cv_transition_active.png',
            normal: '/tools_normal.png',
            title: '无限次简历翻译',
            [`${YEAR_PRICE}title`]: '200次简历翻译',
            [`${MONTH_PRICE}title`]: '10次简历翻译',
            description: '一键生成英文简历',
            life: false,
            plus: false
          },
          // {
          //   img: '/tools_active.png',
          //   normal: '/tools_normal.png',
          //   title: '专业工具',
          //   description: 'AI检查、一键翻译',
          //   life: false,
          //   plus: false
          // },
          {
            img: '/template_active.png',
            normal: '/template_normal.png',
            title: '专属模板',
            [`${MONTH_PRICE}title`]: '会员模板',
            [`${YEAR_PRICE}title`]: '会员模板',
            description: '解锁更多专业模板',
            life: false,
            plus: false
          },
          {
            img: '/image_active.png',
            normal: '/image_normal.png',
            title: '5次证件照制作',
            [`${MONTH_PRICE}title`]: '1次证件照制作',
            [`${YEAR_PRICE}title`]: '1次证件照制作',
            description: '价值19元证件照制作',
            life: false,
            plus: false
          },
          {
            img: '/resume1_active.png',
            normal: '/resume1_normal.png',
            title: '100次简历纠错',
            [`${MONTH_PRICE}title`]: '10次简历纠错',
            [`${YEAR_PRICE}title`]: '10次简历纠错',
            description: 'AI助你完善简历细节',
            life: false,
            plus: false
          },
          {
            img: '/resume_active.png',
            normal: '/resume_normal.png',
            title: '简历修改',
            description: '价值99元辅导优惠券',
            life: true,
            plus: false
          },
          {
            img: '/book_active.png',
            normal: '/book_normal.png',
            title: '求职秘籍',
            description: '价值199元笔面经',
            life: false,
            plus: true
          },
          {
            img: '/course_active.png',
            normal: '/course_normal.png',
            title: '简历课程',
            description: '价值79元在线课程',
            life: false,
            plus: true
          },
          {
            img: '/job_active.png',
            normal: '/job_normal.png',
            title: '求职咨询',
            description: '求职辅导立减500元',
            life: false,
            plus: true
          },
          {
            img: '/1_1_active.png',
            normal: '/1_1_normal.png',
            title: '1V1服务',
            description: '15分钟专属求职答疑',
            life: false,
            plus: true
          },
        ],
        compsState: false,   // 兑换优惠券弹窗开关
        tempComps: {},   // 临时存储使用的优惠券
        isHalfYearMember: false,    // 用户是否半年内购买过月度会员
      }
    },
    computed: {
      ...mapState("me", ["personInfo", 'purchaseRecordData']),
      ...mapGetters('me', ['memberPopupData']),
      headerTips() {
        if (this.browseType === 'cvCheck') {
          return '开通会员AI智能检查不限次数，助你打造完美简历'
        } else if (this.browseType === 'suggestion') {
          return '开通会员查看详细优化建议，让你的简历更专业'
        } else if (this.browseType === 'downloadCv') {
          return '开通会员解锁全部简历样式，让你的简历脱颖而出'
        } else if (this.browseType === 'schoolLogo') {
          return '插入校徽是会员专属功能，开通会员解锁更多权益'
        } else if (this.browseType === 'opus') {
          return '插入作品集是会员专属功能，开通会员解锁更多权益'
        } else if (this.browseType === 'avatar') {
          return '制作证件照是会员专属功能，开通会员解锁更多权益'
        } else if (this.browseType === 'aiCvs') {
          return 'AI 写简历是会员专属功能，开通会员解锁更多权益'
        } else if (this.browseType === 'aiMockInterview') {
          return '开通会员查看满分面试答案，通过率提升80%'
        } else if (this.browseType === 'aiOptimization') {
          return '开通会员查看简历润色结果，让你的简历更专业'
        }
        return '开通会员享受更多特权'
      },
      isSuperMember(){
        return this.personInfo.is_membership && this.personInfo.membership_expired_at.substr(0,4) >= 2100
      },
      isSuper(){
        return function(item) {
          return item.time === '终身会员' || item.time === '超级会员'
        }
      },
      qrPayLink() {
        const currentMemberOption = this.options[this.activeOption];
        return currentMemberOption ? `&memberType=${currentMemberOption.type}&hasRights=${this.hasRights ? '1' : '2'}` : ''
      },
      priceRatio() {
        return this.rightsIds.length > 3 ? 0.5 : (this.rightsIds.length > 1 && this.rightsIds.length < 4 ? 0.8 : 1);
      },
      priceIntroData() {
        const priceIntro = this.options[this.activeOption]
        if (priceIntro) {
          const pickRightsPrice = 
            this.rightsListData
            .filter(item => this.rightsIds.includes(item.id))
            .map(val => ({
              title: val.title,
              price: `¥${this.activeOption === 0 ? 0 : val.price * this.priceRatio}`
            }))
          const pickUnionMemberPrice =
            this.unionMembers
            .filter(item => this.unionMemberIds.includes(item.id))
            .map(val => ({
              title: val.title,
              price: `¥${this.activeOption === 0 ? 0 : val.price}`
            }))
          return {
            membershipIntro: {
              title: priceIntro.time,
              price: `¥${priceIntro.pic}`
            },
            pickRightsPrice,
            pickUnionMemberPrice
          }
        }
      }
    },
    components: {
      qrcodeVue,
      Countdown,
      RemainDialog
    },
    watch: {
      compsState: {
        handler(val) {
          if (val) {
            this.tempComps = {id: this.couponsToken}
          }
        }
      }
    },
    async created() {
      // console.log(this.browseType, this.activePic, "======================>rrrrrrr")
      let host = window.location.origin
      // let host = 'https://www.wondercv.cn'
      let pic = await this.getHalfYearMember()
      // console.log(pic, "====================>pic")
      await this.fetchMemberRightsListData();
      this.handleCreateOrder(this.activePic)
      let data = {}
      if (this.activePic === FOREVER_PRICE || this.activePic === WONDER_PRICE){
        data.coupon_plan = '终身会员'
      }else {
        data.coupon_plan = '超级会员'
      }
      if (pic === FOREVER_PRICE || pic === 80) {
        this.activeOption = 0
      }else if (pic === MONTH_PRICE) {
        this.activeOption = 1
      } else if (pic === YEAR_PRICE) {
        this.activeOption = 2
      } else if (pic === WONDER_PRICE || pic === FOREVER_PLUS_PRICE || pic === 150) {
        this.activeOption = 3
      }
      this.host = host.replace("www", "m")
      // this.host = 'https://m.wondercv.cn'
      this.pic = pic
      let res = await api.account.getSpecialOffers(get_tUser().c_t, data)
      let {code, data: {coupons}} = res
      coupons = coupons.filter(item => item.usable)
      for (let i = 0; i < coupons.length; i += 2) {
        this.couponsList.push(coupons.slice(i, i + 2));
      }
      setTimeout(() => {
        this.isShowBtn = true
      }, 3000)
    },
    async mounted() {
      let count = localStorage.getItem('surplusCount') || 51
      if (count > 8) {
        count -= 1
      }

      this.surplusCount = count > 9 ? String(count) : `0${count}`
      localStorage.setItem('surplusCount', count)

      document.body.style.overflow = 'hidden'
      this.timer = setInterval(() => {
        this.checkOrder()
      }, 3000)
    },
    methods: {
      ...mapActions('me', ['getUserInfo', 'getPurchaseRecordData']),
      getDiscountItemData(vipItem, state) {
        const couponItem = MEMBER_STATE_DATA[state]?.couponList?.find(item => item.type === vipItem.type)
        return {
          ...(couponItem || {}),
          discountPrice: couponItem?.money ? (vipItem.pic * 10 - couponItem.money * 10) / 10 : 0
        }
      },
      includeRighsPrice(vipItem, index) {
        if (this.activeOption === index && vipItem.type !== 'forever') {
          let price = this.rightsListData.reduce((totalPrice, item) =>
            this.rightsIds.includes(item.id) ? totalPrice + item.price : totalPrice, 0);
          
          const unionMembersPrice = this.unionMembers.reduce((totalPrice, item) =>
            this.unionMemberIds.includes(item.id) ? totalPrice + item.price : totalPrice, 0);
            
          price *= this.priceRatio;

          return (vipItem.pic * 10 + price * 10 + unionMembersPrice * 10) / 10
        }
      },
      displayDiscountedPrice(vipItem, index) {
        if (this.purchaseRecordData && this.activeOption === index) {
          const { state } = this.purchaseRecordData;
          switch(state) {
            case ORDER_IN:
              if (vipItem.type === 'forever') {
                return this.getDiscountItemData(vipItem, state)
              }
            case BUY_IN:
              if (vipItem.type === 'forever') {
                return this.getDiscountItemData(vipItem, state)
              }
          }
        }
      },
      currentRealPrice() {
        const vipData = this.options[this.activeOption];
        const discountPriceItem = this.displayDiscountedPrice(vipData, this.activeOption);
        const addRightsPrice = this.includeRighsPrice(vipData, this.activeOption) || 0;
        if (discountPriceItem) {
          return discountPriceItem.discountPrice
        } else {
          return addRightsPrice || vipData.pic
        }
      },
      handleChangeRightsState(data) {
        this.currentRightsDetailImage = data.image;
        this.rightsDetailState = true;
      },
      handleCancelRights(type) {
        const list = type === 'rights' ? this.rightsListData : this.unionMembers;
        const lastPickerId = type === 'rights' ? this.rightsIds[0] : this.unionMemberIds[0]
        const data = list.find(item => item.id === lastPickerId)
        this.updateCurrentOrder(0, data, type)
      },
      async updateCurrentOrder(index, data, type = 'rights') {
        try {
          const currentMembership = this.options[this.activeOption];
          if (!currentMembership) return console.log('未找到当前会员套餐');
          let right_ids =  JSON.parse(JSON.stringify(type === 'rights' ? this.rightsIds : this.unionMemberIds));
          const isIds = Array.isArray(index);

          if (isIds) {
            right_ids = index;
          } else if (index > -1) {
            right_ids.splice(index, 1);
          } else {
            right_ids.push(data.id);
          }

          let realIds = []

          if (type === 'rights') {
            realIds = [...right_ids, ...this.unionMemberIds]
          } else {
            realIds = [...this.rightsIds, ...right_ids]
          }


          const message = await this.handleUpdateOrderInfo({
            member_period: currentMembership.value,
            has_rights: JSON.stringify(this.hasRights),
            right_ids: realIds,
          })
          
          if (message) {
            this.$message.error(message)
          } else {
            if (type === 'rights') {
              this.rightsIds = right_ids
            } else {
              this.unionMemberIds = right_ids
            }
          }
          
          this.$forceUpdate();
          this.remainDialogState = false;
          this.unionRemainState = false
        } catch (error) {
          console.log(error)
        }
      },
      async handleClickRightsItem(data) {
        try {
          if (this.activeOption === 0) {
            this.$message.error('终身会员默认包含，不可取消')
          } else {
            const index = this.rightsIds.findIndex(item => item === data.id);
            if (this.rightsIds.length === 1 && index > -1) {
              this.remainDialogState = true;
            } else {
              this.updateCurrentOrder(index, data, 'rights')
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
      async handleClickUnionMemberItem(data) {
        if (this.activeOption === 0) {
          this.$message.error('终身会员默认包含，不可取消')
        } else {
          const index = this.unionMemberIds.findIndex(item => item === data.id);
          if (this.unionMemberIds.length === 1 && index > -1) {
            this.unionRemainState = true;
          } else {
            this.updateCurrentOrder(index, data, 'union')
          }
        }
      },
      async fetchMemberRightsListData() {
        try {
          const { code, data } = await api.account.fetchMemberRightsList({});
          if (code === 1000) {
            this.rightsListData = data.member_rights?.map(item => ({
              ...item,
              price: item.price / 100,
              crossed_price: item.crossed_price / 100
            }));
            this.rightsIds = this.rightsListData.map(item => item.id);
            this.unionMembers = data.union_members?.map(item => ({
              ...item,
              price: item.price / 100,
              crossed_price: item.crossed_price / 100
            }))

            if (this.activePic === FOREVER_PRICE) {
              this.unionMemberIds = data.union_members?.map(item => item.id)
            } else {
              this.unionMemberIds = data.union_members?.filter(item => item.default_chosen)?.map(v => v.id)
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 点击权益添加跳转
      memberShipClick(obj, index) {
        if (index === 8) {
          window.open(`${location.origin}/course`)
        } else if (index === 6) {
          window.open(`${location.origin}/service/`)
        }
      },
      // 半年内是否购买过会员
      async getHalfYearMember() {
        try {
          // let res = await api.account.isHalfYearMember()
          // if (res.code === 1000 && res.data.state) {
          //   this.isHalfYearMember = true;
          //   let plusMemberPic = this.options[0].pic
          //   let lifeMemberPic = this.options[3].pic
          //   let curPic = lifeMemberPic - 19
          //   let interval = setInterval(() => {
          //     // this.$set(this.options)
          //     if (lifeMemberPic <= curPic) {
          //       clearInterval(interval)
          //     } else {
          //       this.$set(
          //         this.options,
          //         0,
          //         {
          //           id: 3,
          //           pic: -- plusMemberPic,
          //           oldPic: 199,
          //           time: "终身会员",
          //           text: "最实惠 越用越省",
          //           value: 1000
          //         }
          //       )
          //       this.$set(
          //         this.options,
          //         3,
          //         {
          //           id: 4,
          //           pic: -- lifeMemberPic,
          //           oldPic: 1199,
          //           time: "超级会员",
          //           text: "最实惠 越用越省",
          //           value: 1001
          //         }
          //       )
          //     }
          //   }, 40)
          //   return this.activePic === 99 ? 80 : this.activePic === 169 ? 150 : this.activePic
          // } else {
          return this.activePic
          // }
        } catch (e) {
          console.log(e, "==================>获取用户半年内是否购买过会员错误")
          return this.activePic
        }
      },
      // 使用优惠券
      useComps() {
        if (!this.tempComps.id) {
          this.$message.error('请选择优惠券')
          return
        }
        // 判断是否有续费优惠
        if (this.options[0].pic === 100) {
          this.$message.error('优惠券和续费用户折扣不能共享')
          // 选择优惠券优惠之后重置会员价格重新生成订单
          this.$set(
            this.options,
            0,
            {
              id: 4,
              pic: WONDER_PRICE,
              oldPic: 1199,
              time: "终身会员Plus",
              text: "最实惠 越用越省",
              value: 1001
            }
          )
          this.$set(
            this.options,
            1,
            {
              id: 3,
              pic: FOREVER_PRICE,
              oldPic: 299,
              time: "终身会员",
              text: "最实惠 越用越省",
              value: 1000
            }
          )
          this.isHalfYearMember = false
          this.pic = this.options[this.activeOption].pic
        }
        if (this.couponsToken !== this.tempComps.id) {
          this.couponsToken = this.tempComps.id;
          if (this.tempComps.cent) {
            this.couponsPic = this.tempComps.cent / 100
          }else {
            this.couponsPic = this.pic * (1 - this.tempComps.discount)
          }
        }
        this.closeComps()
      },
      // 打开兑换优惠券弹窗
      openComps() {
        this.compsState = true
      },
      // 关闭兑换优惠券弹窗
      closeComps() {
        this.compsState = false
      },
      // 创建订单
      async handleCreateOrder(pic) {
        let _t = Cookies.get('_t');
        if (!_t) {
          toLogin({login:true});
          return
        }
        try {
          let member_period = 1000
          if (pic !== 1000) {
            if (pic === MONTH_PRICE) {
              member_period = 1
            } else if (pic === 45) {
              member_period = 3
            } else if (pic === YEAR_PRICE) {
              member_period = 12
            } else if (pic === FOREVER_PRICE || pic === 80) {
              member_period = 1000
            } else if (pic === WONDER_PRICE || pic === 150) {
              member_period = 1001
            } else if (pic === FOREVER_PLUS_PRICE) {
              member_period = 2000
            }
          }
          let res = await api.account.createOrder({
            member_period,
            has_rights: JSON.stringify(this.hasRights),
            right_ids: [...this.rightsIds, ...this.unionMemberIds]
          })
          let {code, data: {token}} = res
          if (code === 1000) {
            this.getPurchaseRecordData();
            this.orderId = token
            this.showAlert = true

          }
        } catch (e) {
          console.log(e)
        }
      },
      async close() {
        await this.getUserInfo()
        document.body.style.overflow = 'visible'
        this.$emit("close")
        if (this.origin === 'ai-cvs') {
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'ai-cvs',
          })
        }
      },
      handleClickTo(value) {
        this.couponsIndex += value
      },
      async handleUpdateOrderInfo(params) {
        try {
          let res = await api.account.updateOrder(this.orderId, params)
          if (res.code === 600205) {
            return res.message;
          }
        } catch(e) {
          console.log(e);
        }
      },
      //修改价格更新订单
      async handleClickUpdateOrder(pic, value, index, type) {
        // 超级会员切换到终身会员  或者  终身会员切换到超级会员  滚动回第一页显示优惠券
        if (((this.pic == MONTH_PRICE || this.pic == 45) && (pic == FOREVER_PRICE || pic == WONDER_PRICE)) || ((pic == MONTH_PRICE || pic == 45 || pic == YEAR_PRICE) && (pic == FOREVER_PRICE || pic == WONDER_PRICE) )) {
          this.couponsIndex = 0
        }
        let data = {};
        if (value === 1000 || value === 1001) {
          data.coupon_plan = '终身会员'
        } else if (value === 2000) {
          data.coupon_plan = '超级会员plus'
        } else {
          data.coupon_plan = '超级会员'
        }
        // 这里是切换会员类型的时候重新获取了一下优惠券接口
        let specialOffers = await api.account.getSpecialOffers(get_tUser().c_t, data)
        let {code, data: {coupons}} = specialOffers
        this.couponsList = [];
        coupons = coupons.filter(item => item.usable)
        for (let i = 0; i < coupons.length; i += 2) {
          this.couponsList.push(coupons.slice(i, i + 2));
        }
        // 切换会员类型时优惠券重新计算
        let coupon = coupons.filter(item => item.id === this.couponsToken)
        try {
          if (coupon[0].cent) {
            this.couponsPic = coupon[0].cent / 100
          }else {
            this.couponsPic = pic * (1 - coupon[0].discount)
          }
        }catch (e) {
          this.couponsPic = 0

        }
        // 更新了订单的信息
        const ids = this.rightsListData.map(item => item.id);
        const unionMemberIds = this.unionMembers.map(item => item.id)

        if (this.options[this.activeOption].type === 'forever' && type !== 'forever') {
          this.unionMemberIds = this.unionMembers.filter(item => item.default_chosen).map(v => v.id)
        }

        const message = await this.handleUpdateOrderInfo({ 
          member_period: value,
          has_rights: JSON.stringify(this.hasRights),
          right_ids: type === 'forever' ? [...ids, ...unionMemberIds] : [...this.rightsIds, ...this.unionMemberIds]
        });

        if (message) {
          return this.$message.error(message)
        }

				this.activeOption = index
        this.pic = pic

        if (type === 'forever') {
          this.rightsIds = ids;
          this.unionMemberIds = unionMemberIds;
        }
      },
      //选择优惠券
      handleClickSelectCoupons(obj) {
        if ((this.purchaseRecordData?.state === BUY_IN || this.purchaseRecordData?.state === ORDER_IN) && obj.cent > 0) {
          return this.$message.error('优惠无法叠加使用');
        }
        if (this.tempComps.id === obj.id) {
          this.tempComps = {}
        } else {
          this.tempComps = obj
        }
        // if (this.couponsToken == obj.id) {
        //   this.couponsToken = '';
        //   this.couponsPic = 0
        // } else {
        //   this.couponsToken = obj.id;
        //   if (obj.cent) {
        //     this.couponsPic = obj.cent / 100
        //   }else {
        //     this.couponsPic = this.pic * (1 - obj.discount)
        //   }
        // }
      },
      //提交兑换码
      async handleClickSubmit() {
        if (!this.couponsText) {
          this.$message.error("无效兑换码，请检查")
          return
        }
        let datas = {partner: this.couponsText}
        if (this.pic === FOREVER_PRICE || this.pic === WONDER_PRICE){
          datas.coupon_plan = '终身会员'
        }else {
          datas.coupon_plan = '超级会员'
        }
        let res = await api.account.couponsCreate(get_tUser().c_t, datas)
        // let {code, data: {coupons, code_kind}, message} = res
        if (res.code === 1000) {
          this.couponsList = []
          let coupons = res.data.coupons.filter(item => item.usable)
          for (let i = 0; i < coupons.length; i += 2) {
            this.couponsList.push(coupons.slice(i, i + 2));
          }
          // 'code_kind'
          this.couponsText = ""
          if (res.data.code_kind === 'member' && res.data.message.indexOf('30000') > -1) {
            this.$message.success("恭喜成为超级简历终身会员！")
          }else if (res.data.code_kind === 'member') {
            this.$message.success(res.data.message)
          }else {
            this.$message.success(res.data.message)
          }
        } else {
          this.$message.error(res.data ? res.data.error : res.message )
        }
      },
      //0元购买
      async handleClickPay() {
        if (this.isPayLoading) return
        this.isPayLoading = true
        let res = await api.account.orderPay(this.orderId, {coupon_id: this.couponsToken})
        if (res.code === 1000) {
          this.$message.success("支付成功")
          await this.getUserInfo()
          setTimeout(() => {
            let type = this.hasRights ? 'rightsVip' : 'vip'
            if(this.pic == FOREVER_PRICE){
              type = 'super'
            }else if(this.pic == WONDER_PRICE){
              type = 'superplus'
            }else if(this.pic == MONTH_PRICE) {
              type = this.hasRights ? 'rightsMonth' : 'month'
            } else if (this.pic === FOREVER_PLUS_PRICE) {
              type = 'plus'
            }
            routerTo(`/pay/success?orderId=${this.orderId}&type=${type}&state=${this.purchaseRecordData?.state || ''}`)
          }, 500)
          this.close()
        }
        this.isPayLoading = false
      },
      //检查订单
      async handleClickCheck() {
        if (this.isError) {
          return
        }
        this.isError = true
        let res = await api.account.checkOrder(this.orderId)
        if (res.code == 1000) {
          this.getPurchaseRecordData();
          let {status} = res.data
          if (status == 'paid') {
            this.$message.success("支付成功")
            this.isError = false
            await this.getUserInfo()
            setTimeout(() => {
              let type = this.hasRights ? 'rightsVip' : 'vip'
              if(this.pic == FOREVER_PRICE){
                type = 'super'
              }else if(this.pic == WONDER_PRICE){
                type = 'superplus'
              }else if(this.pic == MONTH_PRICE) {
                type = this.hasRights ? 'rightsMonth' : 'month'
              } else if (this.pic === FOREVER_PLUS_PRICE) {
                type = 'plus'
              }
              routerTo(`/pay/success?orderId=${this.orderId}&type=${type}&state=${this.purchaseRecordData?.state || ''}`)
            }, 500)
          } else {
            this.$message.error("订单支付失败，请继续支付")
            this.isError = false
            this.isShowError = true
          }
        } else {
          this.$message.error(res.message)
        }
      },
      //检查订单结果()
      async checkOrder() {
        let res = await api.account.checkOrder(this.orderId)
        if (res.code == 1000) {
          this.getPurchaseRecordData();
          let {status} = res.data
          if (status == 'paid') {
            this.$message.success("支付成功")
            await this.getUserInfo()
            clearInterval(this.timer)
            setTimeout(() => {
              let type = this.hasRights ? 'rightsVip' : 'vip'
              if(this.pic == FOREVER_PRICE){
                type = 'super'
              }else if(this.pic == WONDER_PRICE){
                type = 'superplus'
              }else if(this.pic == MONTH_PRICE) {
                type = this.hasRights ? 'rightsMonth' : 'month'
              } else if (this.pic === FOREVER_PLUS_PRICE) {
                type = 'plus'
              }
              routerTo(`/pay/success?orderId=${this.orderId}&type=${type}&state=${this.purchaseRecordData?.state || ''}`)
            }, 500)
          }
        }
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    }
  }
</script>

<style scoped lang="scss">
  @import './payAlert.scss';
</style>
